<template>
  <div class="card card-content">

    <div class="card-header">
        <div class="header">
        <div class="breadcrumb">
          <a class="breadcrumb-item" v-link="{ path: '/'}">Accueil</a>
          <a class="breadcrumb-item" v-link="{ path: '/contact/list'}">Gestion des participants</a>
          <a class="breadcrumb-item" v-link="{ name: 'editContact', params: { contactId: this.contact.id } }">{{ contact.leader_firstname }} {{ contact.leader_lastname }}</a>
          <a class="breadcrumb-item" v-link="{ name: 'planningContact', params: { contactId: contact.id }}">Planning</a>
        </div>
        <h1>{{ contact.leader_firstname }} {{ contact.leader_lastname }}</h1>
      </div>
      <div class="actions">
        <a class="btn btn-link" v-link="{ path: '/contact/list' }">Voir tous les participants</a>
        <a class="btn btn-link" v-link="{ name: 'addProjectWithContact', params: { contactId: contact.id } }">Ajouter un parcours</a>
        <a class="btn btn-link" v-link="{ name: 'addMeetingWithContact', params: { contactId: contact.id } }">Ajouter un rdv</a>
      </div>
    </div>

    <div class="card-block">
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'editContact', params: { contactId: contact.id }}">Informations</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'parcoursContact', params: { contactId: contact.id }}">Parcours</a>
        </li>
        <li class="nav-item">
          <a class="nav-link active" v-link="{ name: 'planningContact', params: { contactId: contact.id }}">Planning</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'editContact.entreprises', params: { contactId: contact.id }}">Entreprises</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'editContact.emplois', params: { contactId: contact.id }}">Emplois</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'editContact.formations', params: { contactId: contact.id }}">Formations</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'editContact.capes', params: { contactId: contact.id }}">CAPE</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'editContact.cers', params: { contactId: contact.id }}">CER</a>
        </li>
      </ul>
    </div>

    <div class="Calendar CalendarPlanning"></div>

    <div class="card-footer">
      <div class="actions">
        <a class="btn btn-link" v-link="{ path: '/contact/list'}">Voir tous les participants</a>
      </div>
    </div>
  </div>
</template>

<script>
  // Npm imports
  import $ from 'jquery'
  // import moment from 'moment'

  import 'fullcalendar'
  import 'fullcalendar/dist/locale/fr.js'

  // Vuex
  import { contact as currentContact, meetingsContact, selectedDay, meetingDeleted, project, phases, firstintervenants, presences } from 'src/vuex/getters'

  import { getMeetingsForContact, getMeeting, selectDay } from 'src/vuex/actions/meetingActions'
  import { getContact } from 'src/vuex/actions/contactActions'
  import { getProject } from 'src/vuex/actions/projectActions'
  import { getPhases } from 'src/vuex/actions/phaseActions'
  import { getFirstintervenants } from 'src/vuex/actions/firstintervenantActions'
  import { getPresences } from 'src/vuex/actions/presenceActions'

  import { formatMeetingsWithUrl } from 'src/utils/fullcalendar'

  // Local components
  import Breadcrumb from '../nav/Breadcrumb.vue'

  export default {
    vuex: {
      getters: { currentContact, meetingsContact, selectedDay, meetingDeleted, project, phases, firstintervenants, presences },
      actions: { getContact, getMeetingsForContact, getMeeting, selectDay, getProject, getPhases, getFirstintervenants, getPresences }
    },
    components: { Breadcrumb },
    data () {
      return {
        contact: []
      }
    },
    ready () {
      let vm = this

      this.getPhases()
      this.getFirstintervenants()
      this.getPresences()
      this.getContact(this.$route.params.contactId).then(() => {
        vm.contact = JSON.parse(JSON.stringify(vm.currentContact))

        console.log('CALENDAR')
        $('.Calendar').fullCalendar({
          navLinks: false,
          editable: false,
          droppable: false,
          lazyFetching: true,
          eventLimit: true,
          header: {
            left: 'prev,next today',
            center: '',
            right: 'title'
          },
          eventRender: function (calEvent) {
            $(calEvent.el).on('dblclick', function () { console.log('double click! ' + calEvent.id + '!' + calEvent.el.id) })
          },
          eventClick: function (calEvent, jsEvent, view) {
            console.log('event on list ' + calEvent.id)
            console.log(calEvent.id)
            vm.getMeeting(calEvent.id)
          },
          viewRender: function (view, element) {
            vm.selectDay({ time: view.intervalStart.format('DD-MM-YYYY'), origin: 'calendar' })
          },
          minTime: '06:00:00',
          maxTime: '19:00:00',
          lang: 'fr',
          views: {
            listAllYears: {
              type: 'list',
              visibleRange: {
                start: '2000-01-01',
                end: '2030-12-31'
              }
              // duration: { years: 31 },
            }
          },
          defaultView: 'listAllYears',
          eventAfterAllRender: function (view) {
            var renderedEvents = $('.fc-list-table  tr')
            var reorderedEvents = []
            var blockEvents = null
            renderedEvents.map(function (key, event) {
              if ($(event).hasClass('fc-list-heading')) {
                if (blockEvents) {
                  reorderedEvents.unshift(blockEvents.children())
                }
                blockEvents = $('<tbody></tbody>')
              }
              blockEvents.append(event)
            })
            reorderedEvents.unshift(blockEvents.children())
            $('.fc-list-table tbody').html(reorderedEvents)
          },
          events (start, end, timezone, callback) {
            vm.getMeetingsForContact('2000-01-01', end.format('YYYY-MM-DD'), vm.$route.params.contactId)
              .then(() => {
                let lastmeeting = 0
                let firstintervenanttmp = 0
                let nbMeetings = 0
                let projectsId = []
                let lastprojectid = 0
                vm.meetingsContact.forEach(function (meeting) {
                  nbMeetings += 1
                  if (meeting.id > lastmeeting) {
                    lastmeeting = meeting.id
                  }
                  if (meeting.title === 'null' || meeting.title === null) {
                    meeting.title = ''
                  }
                  vm.presences.forEach(function (presence) {
                    if (presence.id === meeting.presence_id) {
                      if (meeting.title !== '') {
                        meeting.title = '(' + presence.name + ') | ' + meeting.title
                      } else {
                        meeting.title = '(' + presence.name + ')'
                      }
                    }
                  })
                  if (!isNaN(meeting.project_id) && typeof (meeting.project_id) === 'number' && meeting.project_id !== 0) {
                    projectsId[meeting.project_id] = meeting.project_id
                    if (meeting.project_id > lastprojectid) {
                      lastprojectid = meeting.project_id
                    }
                  }
                })
                console.log('NB RDV ' + nbMeetings)
                let projectsName = []
                projectsId.forEach(function (projectId) {
                  vm.getProject(projectId)
                    .then(() => {
                      console.log('getproject ' + projectId + ' => ' + ' : ' + vm.project.name)
                      projectsName[projectId] = vm.project.name
                      if (projectId === lastprojectid) {
                        vm.meetingsContact.forEach(function (meeting) {
                          // if (!isNaN(meeting.project_id) && typeof (meeting.project_id) === 'number' && meeting.project_id !== 0 && !isNaN(projectsName[meeting.project_id])) {
                          if (meeting.project_id !== 0) {
                            if (meeting.title.indexOf(projectsName[meeting.project_id]) === -1) {
                              meeting.title = meeting.title + ' | ' + projectsName[meeting.project_id]
                            }
                          }
                          vm.phases.forEach(function (phase) {
                            if (phase.id === meeting.phase_id) {
                              if (meeting.title.indexOf(phase.name) === -1) {
                                meeting.title = meeting.title + ' | ' + phase.name
                              }
                            }
                          })
                          firstintervenanttmp = meeting.firstintervenant_id
                          console.log(meeting.title + ' ' + meeting.firstintervenant_id + ' : intervenant ' + firstintervenanttmp + ' project ' + meeting.project_id + ' : ' + projectsName[meeting.project_id])
                          vm.firstintervenants.forEach(function (firstintervenant) {
                            if (firstintervenant.id === firstintervenanttmp) {
                              if (meeting.title.indexOf(firstintervenant.firstname + ' ' + firstintervenant.lastname) === -1) {
                                meeting.title = meeting.title + ' | ' + firstintervenant.firstname + ' ' + firstintervenant.lastname
                              }
                            }
                          })
                          if (meeting.id === lastmeeting) {
                            // callback(formatMeetingsWithUrl(vm.meetingsContact))
                            setTimeout(function () { console.log('AFTER'); callback(formatMeetingsWithUrl(vm.meetingsContact)) }, 1000)
                          }
                        })
                      }
                    })
                })
              })
          }
        })
      })
    },
    computed: {
      name: function () {
        if (!Array.isArray(this.contact)) {
          return this.contact.leader_firstname + ' ' + this.contact.leader_lastname
        }
      }
    },
    watch: {
      'contact': function () {
        $('.Calendar').fullCalendar('refetchEvents')
      },
      'meetingDeleted' () {
        $('.Calendar').fullCalendar('refetchEvents')
      },
      'selectedDay' (selectedDay) {
        console.log('selectedDay ' + selectedDay.origin)
        if (selectedDay.origin !== 'calendar') {
          // $('.Calendar').fullCalendar('gotoDate', moment(this.selectedDay.time, 'DD-MM-YYYY'))
        }
      }
    }
  }
</script>

<style>
  .CalendarPlanning .fc-header-toolbar{display: none;}
  .CalendarPlanning .fc-list-table td {padding: 2px 14px;}
</style>



// WEBPACK FOOTER //
// ContactPlanning.vue?c4015d48